import sodium from "libsodium-wrappers-sumo";

export interface IdentityKeypair {
  publicKey: Uint8Array;
  privateKey: Uint8Array;
  keyType: "ed25519";
}

export interface EphemeralKeypair {
  publicKey: Uint8Array;
  privateKey: Uint8Array;
  keyType: "x25519";
}

export async function generateIdentityKeypair(): Promise<IdentityKeypair> {
  await sodium.ready;
  const kp = sodium.crypto_sign_keypair();
  return {
    publicKey: kp.publicKey,
    privateKey: kp.privateKey,
    keyType: "ed25519",
  };
}

export async function generateEphemeralKeypair(): Promise<EphemeralKeypair> {
  await sodium.ready;
  const kp = sodium.crypto_box_keypair();
  return {
    publicKey: kp.publicKey,
    privateKey: kp.privateKey,
    keyType: "x25519",
  };
}

export function computeFingerprint(publicKey: Uint8Array): string {
  const hash = sodium.crypto_generichash(8, publicKey);
  return Array.from(hash)
    .map((b) => b.toString(16).padStart(2, "0"))
    .join(":");
}

export function createProofOfPossession(
  privateKey: Uint8Array,
  publicKey: Uint8Array,
): Uint8Array {
  return sodium.crypto_sign_detached(publicKey, privateKey);
}

export function verifyProofOfPossession(
  proof: Uint8Array,
  publicKey: Uint8Array,
): boolean {
  try {
    return sodium.crypto_sign_verify_detached(proof, publicKey, publicKey);
  } catch {
    return false;
  }
}
